<ng-container *ngIf="isVisible">
  <div class="consent-backdrop" *ngIf="generalService.isNativePlatform()"></div>

  <section
    class="consent-shell"
    [class.native]="generalService.isNativePlatform()"
    [class.web]="!generalService.isNativePlatform()"
    role="dialog"
    aria-modal="true"
    aria-labelledby="consent-title"
  >
    <div class="consent-panel" *ngIf="view === 'prompt'">
      <div class="consent-copy">
        <h2 id="consent-title">Privacy Settings</h2>
        <p>
          We use cookies, data, and device identifiers to improve your experience, analyse traffic and usage, and for marketing purposes. By selecting Accept All, you consent to our use of these technologies.
        </p>
        <div class="consent-links">
          <button type="button" (click)="openUrl(cookiePolicyUrl)">Cookie Policy</button>
          <button type="button" (click)="openUrl(privacyPolicyUrl)">Privacy Policy</button>
        </div>
      </div>

      <div class="consent-actions">
        <button type="button" class="secondary" (click)="necessaryOnly()">Necessary Only</button>
        <button type="button" class="secondary" (click)="openSettings()">Settings</button>
        <button type="button" class="primary" (click)="acceptAll()">Accept All</button>
      </div>
    </div>

    <div class="consent-panel settings" *ngIf="view === 'settings'">
      <div class="consent-header">
        <button type="button" class="icon-button" (click)="backToPrompt()" aria-label="Back to consent prompt">
          <span aria-hidden="true">‹</span>
        </button>
        <h2>Privacy Settings</h2>
      </div>

      <div class="setting-row locked">
        <div>
          <h3>Essential</h3>
          <p>Required for secure login, core app features, consent settings, and basic application configuration.</p>
        </div>
        <span>Always on</span>
      </div>

      <label class="setting-row">
        <div>
          <h3>Analytics</h3>
          <p>Helps us understand app usage and improve the experience through Google Analytics, Firebase, and Google Tag Manager.</p>
        </div>
        <input type="checkbox" [(ngModel)]="analyticsEnabled" />
      </label>

      <label class="setting-row">
        <div>
          <h3>Advertising</h3>
          <p>Allows us and Google to use ad storage, ad user data, and ad personalization for more relevant marketing.</p>
        </div>
        <input type="checkbox" [(ngModel)]="adsEnabled" />
      </label>

      <div class="consent-actions">
        <button type="button" class="secondary" (click)="necessaryOnly()">Necessary Only</button>
        <button type="button" class="secondary" (click)="savePreferences()">Save Preferences</button>
        <button type="button" class="primary" (click)="acceptAll()">Accept All</button>
      </div>
    </div>
  </section>
</ng-container>
